<template>
  <div>
    <b-modal
      id="searchResults"
      size="lg"
      ok-only
      ok-title="Chiudi"
      ok-variant="-transparent"
      header-bg-variant="lisaweb"
      @ok="$emit('close')"
      @hidden="$emit('hidden')"
    >
      <!-- no-close-on-esc
      no-close-on-backdrop -->
      <template #modal-header="{ cancel }">
        <div slot="modal-title" class="modal-title">
          <b-icon icon="search"></b-icon>
          <span>Risultati Ricerca Rapida</span>
        </div>
        <button
          type="button"
          class="close"
          title="Chiudi"
          data-dismiss="modal"
          @click="
            $emit('close');
            cancel();
          "
        >
          <base-icon name="close" width="14" height="14"/>
        </button>
      </template>

      <div v-if="groups.length" class="search-results">
        <p class="search-results__intro">
          {{ total }} {{ total === 1 ? "risultato" : "risultati" }} per
          <b>{{ term }}</b>
        </p>
        <section
          v-for="group in groups"
          :key="group.entity"
          class="search-results__group"
        >
          <header class="search-results__head">
            {{ getEntityLabel(group.entity) }}
            <span class="search-results__count">{{ group.rows.length }}</span>
          </header>
          <a
            v-for="row in group.rows"
            :key="row.id"
            href="#"
            class="search-results__row"
            @click.prevent="openEntityModal(row.id, group.entity, row.title)"
          >
            <span class="search-results__main">
              <span class="search-results__name">{{ row.title }}</span>
              <span class="search-results__detail">{{ row.detail }}</span>
            </span>
            <span class="search-results__tags">
              <span
                v-for="tag in row.tags"
                :key="tag.term"
                class="search-results__tag"
              >
                <span class="search-results__kind">{{ tag.kind }}</span>
                {{ tag.term }}
              </span>
            </span>
            <span class="search-results__arrow" aria-hidden="true">›</span>
          </a>
        </section>
      </div>
      <p v-else class="mt-3">Nessun risultato.</p>
    </b-modal>
    <!-- :title="detailTitle" -->
    <b-modal
      :id="searchmodalName"
      size="xl"
      ok-only
      ok-title="Chiudi"
      ok-variant="-transparent"
      header-bg-variant="lisaweb"
      no-close-on-backdrop
      @hidden="onModalHidden"
    >
      <template #modal-header="{ cancel }">
        <div slot="modal-title" class="modal-title">
          <b-icon icon="search"></b-icon>
          <span>{{ detailTitle }} </span>
        </div>
        <button
          type="button"
          class="close"
          title="Chiudi"
          data-dismiss="modal"
          @click="cancel()"
        >
          <base-icon name="close" width="14" height="14"/>
        </button>
      </template>
      <div>
        <b-tabs content-class="pt-1" lazy v-model="tabIndex">
          <b-tab
            v-for="(tab, index) in tabs[entity]"
            :active="index === tabIndex"
            :key="index"
            :title="tab.text"
            @click="setTab(tab, index, entity)"
            title-item-class="lisaweb"
          >
            <keep-alive>
              <component
                v-if="selected === tab.name"
                :is="selected"
                :resourceId="modalResourceId"
              ></component>
            </keep-alive>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>
<script>
import template from "@/components/tables/template";
import BaseIcon from "@/components/BaseIcon";

export default {
  name: "searchResults",
  extends: template,
  data() {
    return {
      modalResourceId: null,
      searchmodalName: "searchResultDetails",
      entity: null,
      selected: null,
      tabIndex: 0,
      tabs: {
        registry: [
          {name: "registryGeneral", text: "Generale"},
          {name: "registryCorrespondences", text: "Indirizzi"},
          {name: "registryInsurancePolicy", text: "Polizze"},
          {name: "registryInsuranceAncillary", text: "Titoli"},
          {name: "registryTakings", text: "Incassi"},
          {name: "registryClaim", text: "Sinistri"},
          {name: "registryAppointments", text: "Appuntamenti"},
          {name: "registryNotes", text: "Note"},
          {name: "registryTodo", text: "Attività"},
          {name: "registryGroup", text: "Gruppi"},
          {name: "registryDocuments", text: "Doc"},
          {name: "registryCommunications", text: "Comunicazioni"},
          {name: "registryRelations", text: "Relazioni"},
        ],
        insurance_policy: [
          {name: "insurance_policyGeneral", text: "Generale"},
          {name: "insurance_policyTechnicalData", text: "Dati tec."},
          {name: "insurance_policyRegistry", text: "Contraente"},
          {name: "insurance_policyGroup", text: "Gruppo"},
          {name: "insurance_policyTitles", text: "Titoli"},
          {name: "insurance_policyAccounting", text: "Incassi"},
          {name: "insurance_policyAccident", text: "Sinistri"},
          {name: "insurance_policyAppointments", text: "Appuntamenti"},
          {name: "insurance_policyNotes", text: "Note"},
          {name: "insurance_policyTodo", text: "Attività"},
          {name: "insurance_policyDocuments", text: "Doc"},
        ],
        claim: [
          {name: "claimGeneral", text: "Generale"},
          {name: "claimRegistry", text: "Anagrafica"},
          {name: "claimPolicy", text: "Polizza"},
          {name: "claimSurveyor", text: "Perito"},
          {name: "claimCounterparties", text: "Controparti"},
          {name: "claimDriver", text: "Conducente"},
          {name: "claimGarage", text: "Officina"},
          {name: "claimAppointments", text: "Appuntamenti"},
          {name: "claimNotes", text: "Note"},
          {name: "claimTodo", text: "Attività"},
          {name: "claimDocuments", text: "Doc"},
        ],
        agency_contact: [
          {name: "agency_contactGeneral", text: "Generale"},
          {name: "agency_contactAppointments", text: "Appuntamenti"},
          {name: "agency_contactNotes", text: "Note"},
          {name: "agency_contactTodo", text: "Attività"},
          {name: "agency_contactDocument", text: "Documenti"},
        ],
      },
    };
  },
  components: {
    BaseIcon,
    registryGeneral: () =>
      import("@/components/wallet/registries/details/General"),
    registryCorrespondences: () =>
      import("@/components/wallet/registries/details/Correspondences"),
    registryInsurancePolicy: () =>
      import("@/components/wallet/registries/details/InsurancePolicy"),
    registryInsuranceAncillary: () =>
      import("@/components/wallet/registries/details/InsuranceAncillary"),
    registryTakings: () =>
      import("@/components/wallet/registries/details/Takings"),
    registryClaim: () => import("@/components/wallet/registries/details/Claim"),
    registryAppointments: () =>
      import("@/components/wallet/registries/details/Appointments"),
    registryTodo: () => import("@/components/wallet/registries/details/Todo"),
    registryNotes: () => import("@/components/wallet/registries/details/Notes"),
    registryGroup: () => import("@/components/wallet/registries/details/Group"),
    registryDocuments: () =>
      import("@/components/wallet/registries/details/Documents"),
    registryCommunications: () =>
      import("@/components/wallet/registries/details/Communications"),
    registryRelations: () =>
      import("@/components/wallet/registries/details/Relations"),
    registryPrints: () =>
      import("@/components/wallet/registries/details/Prints"),

    insurance_policyGeneral: () =>
      import("@/components/wallet/policies/details/General"),
    insurance_policyTechnicalData: () =>
      import("@/components/wallet/policies/details/TechnicalData"),
    insurance_policyRegistry: () =>
      import("@/components/wallet/policies/details/Registry"),
    insurance_policyGroup: () =>
      import("@/components/wallet/policies/details/Group"),
    insurance_policyTitles: () =>
      import("@/components/wallet/policies/details/Titles"),
    insurance_policyAccident: () =>
      import("@/components/wallet/policies/details/Claims"),
    insurance_policyNotes: () =>
      import("@/components/wallet/policies/details/Notes"),
    insurance_policyTodo: () =>
      import("@/components/wallet/policies/details/Todo"),
    insurance_policyAccounting: () =>
      import("@/components/wallet/policies/details/Accounting"),
    insurance_policyAppointments: () =>
      import("@/components/wallet/policies/details/Appointments"),
    insurance_policyDocuments: () =>
      import("@/components/wallet/policies/details/Documents"),

    agency_contactTodo: () =>
      import("@/components/wallet/agency-contacts/details/Todo"),
    agency_contactGeneral: () =>
      import("@/components/wallet/agency-contacts/details/General"),
    agency_contactDocument: () =>
      import("@/components/wallet/agency-contacts/details/Documents"),
    agency_contactNotes: () =>
      import("@/components/wallet/agency-contacts/details/Notes"),
    agency_contactAppointments: () =>
      import("@/components/wallet/agency-contacts/details/Appointments"),

    claimGeneral: () => import("@/components/wallet/claims/details/General"),
    claimRegistry: () => import("@/components/wallet/claims/details/Registry"),
    claimPolicy: () => import("@/components/wallet/claims/details/Policy"),
    claimSurveyor: () => import("@/components/wallet/claims/details/Surveyor"),
    claimCounterparties: () =>
      import("@/components/wallet/claims/details/Counterparties"),
    claimGarage: () => import("@/components/wallet/claims/details/Garage"),
    claimNotes: () => import("@/components/wallet/claims/details/Notes"),
    claimTodo: () => import("@/components/wallet/claims/details/Todo"),
    claimDriver: () => import("@/components/wallet/claims/details/Driver"),
    claimAppointments: () =>
      import("@/components/wallet/claims/details/Appointments"),
    claimDocuments: () =>
      import("@/components/wallet/claims/details/Documents"),
  },
  props: {
    // Risposta di /tags: un elemento per tag, con i record trovati in
    // found[] (un oggetto { entità: [record] } per entità).
    results: {
      type: Array,
      default() {
        return [];
      },
    },
    term: String,
  },
  methods: {
    openEntityModal(id, entity, title) {
      this.modalResourceId = id;
      this.entity = entity;
      this.selected = `${entity}General`;
      this.detailTitle = `${this.getEntityLabel(entity)}${
        title ? `:: ${title}` : ""
      }`;
      this.$bvModal.show(this.searchmodalName);
    },
    onModalHidden() {
      // override template's deinition
      this.entity = null;
      this.selected = null;
      this.tabIndex = 0;
    },
    getEntityLabel(entity) {
      let ret = "";
      switch (entity) {
        case "registry":
          ret = "Anagrafiche";
          break;
        case "agency_contact":
          ret = "Contatti";
          break;
        case "claim":
          ret = "Sinistri";
          break;
        case "insurance_policy":
          ret = "Polizze";
          break;
      }
      return ret;
    },
    // Riga sotto il nome: dove sta, come contattarlo / numero e contraente.
    getDetail(result, entity) {
      const contacts = (result.address_books || []).map(
        (book) => book.attributables || {}
      );
      const mail = contacts.find((c) => c.MAIL)?.MAIL;
      const phone = contacts.map((c) => c.CELL || c.PHON).find(Boolean);
      let properties = [];
      switch (entity) {
        case "registry":
        case "agency_contact":
          properties = [
            this.toInfoData(result, "address", null, " ").trim(),
            mail,
            phone,
          ];
          break;
        case "insurance_policy":
          properties = [
            result.number,
            result.insurance_risk?.title,
            result.registry?.title,
          ];
          break;
        case "claim":
          properties = [
            result.number,
            result.insurance_policy?.number,
            result.insurance_policy?.registry?.title,
          ];
          break;
      }
      return properties.filter(Boolean).join(" · ");
    },
    // Il campo da cui viene il tag: /tags non lo dice, si ricava
    // confrontando il termine con i dati del record. Codice fiscale e
    // partita IVA delle anagrafiche non sono nella risposta: si riconoscono
    // dalla forma.
    getTagKind(term, result, entity) {
      const same = (value) =>
        value != null &&
        String(value).trim().toLowerCase() === term.trim().toLowerCase();
      if (same(result.title)) return null; // si vede già nel nome
      if (entity === "insurance_policy") {
        if (same(result.number)) return "N. polizza";
        if (same(result.insurance_risk?.title)) return "Rischio";
        return "Targa";
      }
      if (entity === "claim") return "N. sinistro";
      for (const book of result.address_books || []) {
        const a = book.attributables || {};
        if (same(a.MAIL)) return "Email";
        if (same(a.CELL)) return "Cellulare";
        if (same(a.PHON)) return "Telefono";
      }
      for (const place of result.correspondences || []) {
        if (same(place.geo_location?.COUNCIL)) return "Comune";
        // il tag è solo la prima riga dell'indirizzo
        if (same(place.attributables?.ADDR?.split("\n")[0])) {
          return "Indirizzo";
        }
      }
      // 11 cifre: partita IVA o codice fiscale di una società
      if (/^\d{11}$/.test(term)) return "C.F. / P. IVA";
      if (/^[a-z0-9]{16}$/i.test(term)) return "Codice fiscale";
      return "Tag";
    },
    // openResult(id, entity) {
    //   // switch (entity) {
    //   //   case "registry":
    //   //     break;
    //   //   case "agency_contact":
    //   //     break;
    //   //   case "claim":
    //   //     break;
    //   //   case "insurance_policy":
    //   //     break;
    //   // }
    //   // this.openModal(id, entity);
    // },
  },
  computed: {
    // Per tipo (anagrafiche, polizze...), un record per riga con i tag che
    // l'hanno fatto trovare: un record trovato da più tag compare una volta.
    groups() {
      const order = ["registry", "insurance_policy", "claim", "agency_contact"];
      const byEntity = {};
      for (const tag of this.results) {
        for (const found of tag.found || []) {
          for (const [entity, records] of Object.entries(found || {})) {
            for (const result of records || []) {
              // Map: tiene l'ordine di arrivo (per affinità), un oggetto
              // ordinerebbe le chiavi numeriche.
              const rows = (byEntity[entity] = byEntity[entity] || new Map());
              if (!rows.has(result.id)) {
                rows.set(result.id, {
                  id: result.id,
                  title: result.title,
                  detail: this.getDetail(result, entity),
                  tags: [],
                });
              }
              const row = rows.get(result.id);
              const kind = this.getTagKind(tag.term, result, entity);
              if (kind && !row.tags.some((t) => t.term === tag.term)) {
                row.tags.push({ term: tag.term, kind });
              }
            }
          }
        }
      }
      return order
        .filter((entity) => byEntity[entity])
        .map((entity) => ({
          entity,
          rows: [...byEntity[entity].values()],
        }));
    },
    total() {
      return this.groups.reduce((sum, group) => sum + group.rows.length, 0);
    },
    selTab: {
      set(value) {
        this.selected = value;
      },
      get() {
        return this.selected;
      },
    },
  },
  // mounted() {
  //   this.$refs['myRelation'].firstChild.addEventListener('click', function(event) {
  //     event.preventDefault();
  //     console.log('clicked: ', event.target);
  //   })
  // },
  beforeMount() {
  },
};
</script>
<style lang="scss" scoped>
.search-results__intro {
  margin: 4px 0 14px;
  color: var(--color-text-muted);

  b {
    color: var(--color-text);
  }
}

.search-results__group {
  margin-bottom: 14px;
  overflow: hidden;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.search-results__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  font-weight: 600;
  background: var(--gray-50);
  border-bottom: 1px solid var(--color-border);
}

.search-results__count {
  padding: 1px 7px;
  font-size: var(--font-size-xs);
  font-weight: 600;
  color: white;
  background: var(--lisaweb);
  border-radius: var(--radius-pill);
}

.search-results__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: 0;
  }

  &:hover,
  &:focus {
    background: var(--color-row-odd);
  }
}

.search-results__main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.search-results__name {
  font-weight: 600;
  color: var(--lisaweb);
}

.search-results__detail {
  overflow: hidden;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.search-results__tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
  max-width: 45%;
}

.search-results__tag {
  padding: 1px 8px;
  font-size: var(--font-size-sm);
  white-space: nowrap;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
}

.search-results__kind {
  color: var(--color-text-muted);
}

.search-results__arrow {
  color: var(--gray-500);
}
</style>
